import { bind, Component, h, signal, tag } from "omi";
import classNames from "classnames";

import { tailwind } from "@/tailwind";

interface Props {
  count: number;
  limit: number;
}

@tag("nw-character-count")
export class NWCharacterCount extends Component<Props> {
  static css = [tailwind];
  static propTypes = {
    count: Number,
    limit: Number,
  };

  private showPulse = signal(false);

  @bind
  private charactersLeft(): number {
    return Math.max(Math.abs(this.props.limit) - Math.abs(this.props.count), 0);
  }

  @bind
  private isNearLimit(): boolean {
    return this.charactersLeft() <= Math.floor(this.props.limit * 0.2);
  }

  @bind
  private isAtLimit(): boolean {
    return this.charactersLeft() <= 0;
  }

  @bind
  private progress(): number {
    return Math.min(this.props.count / this.props.limit, 1);
  }

  @bind
  private getCircleColor(): string {
    if (this.isAtLimit()) return "#FF3B30";
    if (this.isNearLimit()) return "#FFCC00";
    return "#1B1918";
  }

  render() {
    const progressOffset = 100 - this.progress() * 100;

    return (
      <div class={`relative w-10 h-10 ${this.showPulse.value ? "animate-pulse" : ""} rounded-full bg-white/90`}>
        <svg class="w-full h-full" viewBox="0 0 36 36">
          <path d="M18 2.5a15.5 15.5 0 100 31 15.5 15.5 0 000-31z" fill="none" stroke="#E7E5E4" stroke-width="3" />
          <path
            d="M18 2.5a15.5 15.5 0 100 31 15.5 15.5 0 000-31z"
            fill="none"
            stroke={this.getCircleColor()}
            stroke-width="3"
            stroke-dasharray="100"
            stroke-dashoffset={-progressOffset}
            stroke-linecap="round"
            transform="rotate(0 18 18)"
          />
        </svg>
        <div
          class={classNames("absolute inset-0 flex items-center justify-center transition-colors duration-100", [
            `text-[${this.getCircleColor()}]`,
          ])}
        >
          <span class="text-xs font-medium">{this.charactersLeft()}</span>
        </div>
      </div>
    );
  }
}
